import { HomeNavModule } from '@/components/modules/HomeNav';
import { MetricsHomeModule } from '@/components/modules/Metrics/MetricsHome';
import { MetricsHomeMerchantChannelAgentModule } from '@/components/modules/Metrics/MetricsHomeMerchantChannelAgent';
import { MetricsHomeMerchantGroupModule } from '@/components/modules/Metrics/MetricsHomeMerchantGroup';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { WIDGETS } from '@/components/views/DynamicPageView/config/shared/widgets';
import { ALL_APP_ROLES, APP_USER_TYPES } from '@/config/config';
import { PageScheme } from '@/config/types';

export const PAGE_HOME: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.HOME,
  schemesByRoles: [
    {
      roles: [...ALL_APP_ROLES],
      titleTextId: 'HOME',
      widgets: [
        {
          id: WIDGETS.HOME_PAGE_TITLE,
          props: {},
          roles: [...ALL_APP_ROLES],
          notShownInRightMenu: true,
        },
      ],
    },
  ],
  sections: [
    {
      textId: undefined,
      module: (
        <MetricsHomeModule
          permissions={{
            view: [APP_USER_TYPES.SUPER_ADMIN, APP_USER_TYPES.ADMIN],
          }}
        />
      ),
    },
    {
      textId: undefined,
      module: (
        <MetricsHomeMerchantGroupModule
          permissions={{
            view: [APP_USER_TYPES.MERCHANT_GROUP],
          }}
        />
      ),
    },
    {
      textId: undefined,
      module: (
        <MetricsHomeMerchantChannelAgentModule
          permissions={{
            view: [APP_USER_TYPES.MERCHANT, APP_USER_TYPES.CHANNEL, APP_USER_TYPES.AGENT],
          }}
        />
      ),
    },
    {
      textId: undefined,
      module: (
        <HomeNavModule
          permissions={{
            view: [
              // APP_USER_TYPES.SUPER_ADMIN,
              // APP_USER_TYPES.ADMIN,
              // APP_USER_TYPES.MERCHANT_GROUP,
              // APP_USER_TYPES.MERCHANT,
              // APP_USER_TYPES.CHANNEL,
              // APP_USER_TYPES.AGENT,
              APP_USER_TYPES.PARTNER,
              APP_USER_TYPES.LENDER,
              APP_USER_TYPES.THIRD_PARTY_VALIDATION,
              APP_USER_TYPES.CPC_BACK_OFFICE,
            ],
          }}
        />
      ),
    },
  ],
};
